import {
  Button,
  Card,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Radio,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScreenHeader } from "shared/redux/common-reducer";
import { ReactComponent as IconEdit } from "../../../src/assets/images/editIconBlack.svg";
import { RootState } from "shared/redux/store";
import "./InvoiceDetails.scss";
import "../../../src/App.scss";
import { InfoCircleOutlined } from "@ant-design/icons";
import { GSTIN_REGEX, PAN_REGAX, PINCODE_REGAX, SPACE_REGEX } from "shared/constants/AppConstants";
import API_SERVICE from "shared/services/api-service";
import BlueCircleImg from "../../../src/assets/images/Blue Circle.svg";
import InvoiceImg from "../../../src/assets/images/Invoice.svg";
import { setTenantInfo } from "shared/redux/tenant-reducer";
import AppLoading from "shared/components/AppLoading/AppLoading";
import { getUser } from "shared/services/Utility";

type Props = {};

const InvoiceDetails: React.FunctionComponent<Props> = () => {
  const tenant: any = useSelector((state: RootState) => state.tenant);
  const dispatch = useDispatch();
  const [invoiceForm] = Form.useForm();
  const [newAddressForm] = Form.useForm();
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const [isNewBillingAddress, setIsNewBillingAddress] = useState(false);
  const { appColors }: any = useSelector((state: RootState) => state.common);
  const [billingAddress, setBillingAddress] = useState<any[]>([]);
  const btnPrimaryStyles: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
  };
  const btnDefaultBorderStyleWidth: any = {
    "--borderColor": appColors?.appSecondaryColor ?? "",
    minWidth: "100px",
    borderRadius: "6px",
  };
  const btnPrimaryStylesWidth: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    minWidth: "100px",
    borderRadius: "6px",
  };
  const [isEdit, setIsEdit] = useState(false);
  const [isAddressEdit, setIsAddressEdit] = useState(false);
  const [editAddress, setEditAddress] = useState([]) as any;
  const [isPanEdit, setIsPanEdit] = useState(false);
  const [isInvoiceSubjectEdit, setIsInvoiceSubjectedit] = useState(false);
  const [isAddressIdEdit, setIsAddressIdEdit] = useState<number | null>(null);
  const isConnectorInvoicingEnabled =
    tenant?.tenantInfo?.connectorInvoicingEnabled;
  const billingDetails =
    tenant?.tenantInfo?.tenantInvoicingConfig?.billingDetails;

  useEffect(() => {
    dispatch(setScreenHeader({ screenTitle: "Invoice Details" }));
    getTenantInvoiceDetails();
  }, []);

  useEffect(() => {
    getTenantInvoiceDetails();
  }, [tenant]);

  const getTenantInvoiceDetails = () => {
    let billToAddress = billingDetails?.billingAddress;
    let defaultBillingIndex =
      Array.isArray(billToAddress) && billToAddress.length > 0
        ? billToAddress.findIndex((address) => address.defaultAddress)
        : -1;
    setSelectedAddress(defaultBillingIndex != -1 ? defaultBillingIndex : 0);
    setBillingAddress(billToAddress);
    invoiceForm.setFieldsValue({
      billTo: billingDetails?.billTo,
      billingAddress: defaultBillingIndex != -1 ? defaultBillingIndex : 0,
      pan: billingDetails?.pan,
      invoiceSubject: billingDetails?.invoiceSubject,
    });
    if (billingDetails?.saved === false) {
      updateTenantDetails(billToAddress);
    }
  };

  const updateTenantDetails = (billToAddress: any) => {
    const tenantId = getUser()?.businessId;
    const tenantInvoicingConfig = {
      ...tenant?.tenantInfo?.tenantInvoicingConfig,
      billingDetails: {
        saved: true,
        billTo: invoiceForm.getFieldValue("billTo"),
        pan: invoiceForm.getFieldValue("pan"),
        invoiceSubject: invoiceForm.getFieldValue("invoiceSubject"),
        billingAddress: billToAddress,
      },
    };
    const params = { tenantInvoicingConfig: tenantInvoicingConfig };
    API_SERVICE.updateTenantDetails(tenantId, params)
      .then(({ data }) => {
        let payload = {
          ...tenant?.tenantInfo,
          tenantInvoicingConfig: tenantInvoicingConfig,
          connectorInvoicingEnabled:
            tenant?.tenantInfo?.connectorInvoicingEnabled ?? false,
        };
        dispatch(setTenantInfo(payload));
        notification.success({ message: data?.message });
      })
      .catch((e: any) =>
        notification.error({ message: API_SERVICE.handleErrors(e) })
      );
  };

  const handleFormSave = () => {
    updateTenantDetails(billingAddress);
    resetFlags();
  };

  const resetFlags = () => {
    setIsEdit(false);
    setIsAddressEdit(false);
    setIsPanEdit(false);
    setIsInvoiceSubjectedit(false);
  };

  const handleDefaultChange = (index: number) => {
    let updatedAddress = billingAddress.map((address, i) => ({
      ...address,
      defaultAddress: index === i,
    }));
    setBillingAddress([...updatedAddress]);
    setSelectedAddress(index);
  };

  const renderAddress = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          maxHeight: "400px",
          overflow: "hidden",
          overflowY: "auto",
        }}
      >
        <Form.Item name="billingAddress">
          <Radio.Group
            className="invoice-radio"
            value={selectedAddress}
            onChange={(e) => handleDefaultChange(e?.target?.value)}
          >
            {billingAddress?.map((address, index) => (
              <Card
                key={index}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  paddingRight: "10px",
                  marginTop: index !== 0 ? "10px" : "0px",
                  // maxWidth: "470px",
                }}
              >
                <Radio value={index} style={{ fontWeight: "bold" }}>
                  Mark as Default Address
                </Radio>
                <div
                  style={{
                    marginTop: "5px",
                    lineHeight: "1.5",
                    borderRadius: "10px",
                    border: "0.5px solid #ffffff",
                  }}
                >
                  GSTIN: {address.gstin} <br />
                  {address.addressLine} <br />
                  {address.city}, {address.state}, {address.pincode}
                </div>
                <IconEdit
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    cursor: "pointer",
                    color: "#673ab7",
                  }}
                  onClick={() => {
                    setIsAddressEdit(true);
                    setIsNewBillingAddress(true);
                    setEditAddress(address);
                    setIsAddressIdEdit(index);
                  }}
                />
              </Card>
            ))}
          </Radio.Group>
        </Form.Item>
      </div>
    );
  };

  const handleFormSubmit = (values: any) => {
    let newAddress = [...billingAddress];
    let tmpAddress = {
      defaultAddress: false,
      gstin: values?.gstIn,
      addressLine: values?.addressLine,
      pincode: values?.pincode,
      city: values?.city,
      state: values?.state,
    };
    if (isAddressIdEdit != null) {
      newAddress[isAddressIdEdit] = tmpAddress;
    } else {
      newAddress.push(tmpAddress);
    }
    updateTenantDetails(newAddress);
    setIsNewBillingAddress(false);
  };

  const renderFallBackErrorScreen = () => {
    return (
      <div className="content-box">
        <div className="image-container">
          <img
            src={BlueCircleImg}
            alt="Background"
            style={{ width: "200px", height: "200px" }}
          />
          <img
            src={InvoiceImg}
            alt="Overlay"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100px",
              height: "100px",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          <p style={{ fontSize: "26px" }}>
            The Invoicing Module is currently disabled.
          </p>
          <p style={{ fontSize: "26px" }}>
            Contact the administration team to enable it.
          </p>
        </div>
      </div>
    );
  };

  const renderNewAddress = () => {
    if (isAddressEdit) {
      newAddressForm.setFieldsValue({
        gstIn: editAddress?.gstin,
        addressLine: editAddress?.addressLine,
        city: editAddress?.city,
        state: editAddress?.state,
        pincode: editAddress?.pincode,
      });
    } else {
      newAddressForm.resetFields();
    }
    return (
      <Modal
        title="Add New Billing Address"
        visible={isNewBillingAddress}
        width={400}
        footer={null}
        closable={false}
      >
        <div style={{ marginBlock: "10px" }}>
          <Form
            layout="vertical"
            form={newAddressForm}
            onFinish={handleFormSubmit}
          >
            <Form.Item
              name="gstIn"
              label="GSTIN"
              rules={[
                {
                  required: true,
                  pattern: GSTIN_REGEX,
                  message: "Invaid GSTIN provided, please enter again",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter GSTIN"></Input>
            </Form.Item>
            <Form.Item
              name="addressLine"
              label="Address Line"
              rules={[{ required: true, message: "Please enter Address Line" }]}
            >
              <Input
                className="custom-input"
                placeholder="Enter Address Line"
              ></Input>
            </Form.Item>
            <Form.Item
              name="pincode"
              label="Pincode"
              rules={[
                {
                  required: true,
                  pattern: PINCODE_REGAX,
                  message: "Please enter Pincode",
                },
              ]}
            >
              <Input
                className="custom-input"
                placeholder="Enter Pincode"
              ></Input>
            </Form.Item>
            <Form.Item
              name="city"
              label="City"
              rules={[
                {
                  required: true,
                  message: "Please enter City",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter City"></Input>
            </Form.Item>
            <Form.Item
              name="state"
              label="State"
              rules={[
                {
                  required: true,
                  message: "Please enter State",
                },
              ]}
            >
              <Input className="custom-input" placeholder="Enter State"></Input>
            </Form.Item>
            <div className="invoice-button">
              <Button
                className="dynamic-btn-default-cancel"
                style={btnDefaultBorderStyleWidth}
                onClick={() => setIsNewBillingAddress(false)}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="dynamic-btn-default-submit"
                style={btnPrimaryStylesWidth}
              >
                Add
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    );
  };

  if (Object.keys(tenant?.tenantInfo ?? {}).length == 0) {
    return <AppLoading />;
  }

  return (
    <>
      {!isConnectorInvoicingEnabled ? (
        renderFallBackErrorScreen()
      ) : (
        <div className="content-box">
          <Form layout="vertical" form={invoiceForm} onFinish={handleFormSave}>
            <div className="invoice-content-box">
              <div
                style={{
                  backgroundColor: "#396EF614",
                  color: "#273896C4",
                  paddingBlock: "5px",
                  paddingInline: "10px",
                  borderRadius: "8px",
                }}
              >
                All the listed data points are mandatory for successful invoice generation. Please ensure all required data points are configured before proceeding.
              </div>
              <div style={{ maxWidth: "500px" }}>
                <span>
                  <Divider orientation="left" orientationMargin="0">
                    <b> Bill Details</b>
                  </Divider>
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <p style={{ fontSize: "20px" }}> Bill To</p>
                  <Button
                    type="primary"
                    className="editButton"
                    icon={<IconEdit onClick={() => setIsEdit(true)} />}
                  />
                </div>
                <Form.Item
                  name="billTo"
                  className="field-bg"
                  rules={[
                    {
                      required: billingDetails?.billTo,
                      message: "Please enter Bill To",
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    placeholder="Enter Bill To"
                    readOnly={!isEdit}
                  />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    fontSize: "20px",
                  }}
                >
                  <p style={{ fontSize: "20px" }}>Billing Address</p>
                  <Button
                    type="primary"
                    className="AddButton"
                    onClick={() => setIsNewBillingAddress(true)}
                  >
                    Add New Address
                  </Button>
                </div>
                {renderAddress()}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <p style={{ fontSize: "20px" }}> PAN</p>
                  <Button
                    type="primary"
                    className="editButton"
                    icon={<IconEdit onClick={() => setIsPanEdit(true)} />}
                  />
                </div>
                <Form.Item
                  name="pan"
                  className="field-bg"
                  rules={[
                    {
                      required: billingDetails?.pan,
                      message: "Please enter PAN",
                    },
                    {
                      pattern: PAN_REGAX,
                      message: "Please enter valid PAN",
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    placeholder="Enter PAN"
                    readOnly={!isPanEdit}
                  />
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <div style={{ fontSize: "20px", marginBottom:"10px", display:'flex', alignContent:'center' }}>
                    Invoice Subject
                    <Tooltip title="Enter the text to be displayed on the connector invoice. (e.g., 'Referral fee as per Annexure')">
                      <InfoCircleOutlined
                        style={{ color: "grey", marginLeft: "5px", marginTop:"7px" }}
                      />
                    </Tooltip>
                  </div>
                  <Button
                    type="primary"
                    className="editButton"
                    icon={
                      <IconEdit onClick={() => setIsInvoiceSubjectedit(true)} />
                    }
                  />
                </div>
                <Form.Item
                  name="invoiceSubject"
                  className="field-bg"
                  rules={[
                    {
                      required: billingDetails?.invoiceSubject,
                      message: "Please enter Invoice Subject",
                    },
                    {
                      pattern: SPACE_REGEX,
                      message: "Please enter valid Invoice Subject",
                    },
                  ]}
                >
                  <Input
                    className="custom-input"
                    placeholder="Enter Invoice Subject"
                    readOnly={!isInvoiceSubjectEdit}
                  />
                </Form.Item>
              </div>
              {isNewBillingAddress && renderNewAddress()}
            </div>
            <div
              style={{ marginTop: "10px", marginLeft: "auto", width: "100px" }}
            >
              <Button
                className="dynamic-btn-default-submit"
                style={btnPrimaryStyles}
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};

export default InvoiceDetails;
